import style from './index.module.scss';
import clsx from 'clsx';

function BurgerButton({ isOpen, setOpen }) {
    return (
        <div className={clsx(style.button, isOpen && style.open)} onClick={() => setOpen((old) => !old)}>
            <span className={style.line} />
            <span className={style.line} />
            <span className={style.line} />
        </div>
    );
}

export default BurgerButton;
